<template>
  <v-row>
    <v-col>
      <v-sheet elevation="0" style="overflow-y: auto; height: 300px;">
        <Ticket
          :id="ticket.id"
          :serialNumber="ticket.serialNumber"
          :connected="ticket.connected"
          :version="ticket.version"
          :specs="ticket.specs"
          :openedBy="ticket.issuerUsername"
          :openedOn="ticket.createdAt"
          :callerName="ticket.originatorName"
          :callerEmail="ticket.originatorEmail"
          :techOnSite="ticket.techOnSite"
          :disposition="ticket.disposition"
          :inService="ticket.inService"
          :description="ticket.description"
          :circumstance="ticket.circumstance"
          :issueStartedOn="ticket.issueStartedOn"
          :environment="ticket.environment"
          :exhibitingNow="ticket.exhibitingNow"
          :reproducible="ticket.reproducible"
          :attemptedResolution="ticket.attemptedResolution"
          :componentsReplaced="ticket.componentsReplaced"
          :other="ticket.other"
        ></Ticket>
      </v-sheet>
    </v-col>
    <v-col>
      <v-card flat style="overflow-y: auto; height: 300px; background-color: #F5F5F5;">
        <Comment
          v-for="(item, index) in ticket.comments"
          :author="item.authorUsername"
          :time="item.createdAt"
          :text="item.text"
          :key="item.id"
        >
        </Comment>
        <div
          v-if="ticket.comments && ticket.comments.length === 0"
          class="pa-3"
          style="background-color: black; color: white; text-align: center;"
        >
          NO COMMENTS
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import Comment from './Comment.vue';
import Ticket from './Ticket.vue';

export default {
  components: {
    Ticket,
    Comment,
  },

  props: {
    ticket: Object,
  },
};

</script>
